import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23438685"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "skeleton"
}

import { getSatelliteVisibility } from '@/services/satellites.services';
import { onMounted, ref, watch } from 'vue';
import { weatherLocation } from '@/states/homeState';
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  BarElement,
  LinearScale,
  TimeSeriesScale,
  Tooltip,
  Title,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { TChartData, TChartOptions } from 'vue-chartjs/dist/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SatelliteVisibilityWidget',
  setup(__props) {

ChartJS.register(Tooltip, Title, BarElement, LinearScale, TimeSeriesScale);

const loading = ref(true);
const chartData = ref<TChartData<'bar', number[], string>>({ labels: [], datasets: [] });
const chartOptions = ref<TChartOptions<'bar'>>({
  responsive: true,
  plugins: {
    title: {
      text: 'GPS Satellite Visibility (24 hrs)',
      display: true,
    },
    legend: { display: false },
  },
  scales: {
    x: {
      type: 'timeseries',
      time: { tooltipFormat: 'PP p' },
      // title: { display: true, text: 'Timestamp' },
      grid: { drawOnChartArea: false },
      ticks: {
        major: { enabled: true },
        font: (ctx) => {
          if (ctx.tick?.major) {
            return { weight: 'bold' };
          }
        },
      },
    },
    y: {
      title: { display: true, text: 'No. of Satellite Visibile' },
      grid: { drawOnChartArea: false },
    },
  },
});

const getData = async () => {
  loading.value = true;
  const [lat, long] = weatherLocation.value;
  const result = await getSatelliteVisibility(lat, long);

  if (result.data.success) {
    // chartData.value = {
    //   labels: result.data.datetime_range.map((timestamp) =>
    //     dayjs(timestamp).format('MMMM D, YYYY h:mm A')
    //   ),
    //   datasets: [{ data: result.data.visible_sat_in_range }],
    // };
    chartData.value.labels = result.data.datetime_range;
    chartData.value.datasets = [
      {
        data: result.data.visible_sat_in_range,
        label: 'Satellites',
        backgroundColor: 'rgba(255, 102, 0, 0.3)',
      },
    ];
  }
  loading.value = false;
};

watch(weatherLocation, () => {
  getData();
});

onMounted(() => {
  getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createBlock(_unref(Bar), {
          key: 1,
          "chart-options": chartOptions.value,
          "chart-data": chartData.value
        }, null, 8, ["chart-options", "chart-data"]))
  ]))
}
}

})